export const openingBrace = '{';
export const closingBrace = '}';
export const startComment = '/* -------';
export const slashComment = '//';
export const endComment = '------- */';